var map = {
	"./Aboutus.js": "./src/pages/Aboutus.js",
	"./Developers.js": "./src/pages/Developers.js",
	"./En/AboutUs/AboutPayretailers.js": "./src/pages/En/AboutUs/AboutPayretailers.js",
	"./En/AboutUs/Ethics.js": "./src/pages/En/AboutUs/Ethics.js",
	"./En/AboutUs/Events.js": "./src/pages/En/AboutUs/Events.js",
	"./En/AboutUs/New.js": "./src/pages/En/AboutUs/New.js",
	"./En/AboutUs/WorkWithUs.js": "./src/pages/En/AboutUs/WorkWithUs.js",
	"./En/AboutUs/index.js": "./src/pages/En/AboutUs/index.js",
	"./En/Developers/Help.js": "./src/pages/En/Developers/Help.js",
	"./En/Developers/Integrations.js": "./src/pages/En/Developers/Integrations.js",
	"./En/Home.js": "./src/pages/En/Home.js",
	"./En/Markets/Africa.js": "./src/pages/En/Markets/Africa.js",
	"./En/Markets/Brasil.js": "./src/pages/En/Markets/Brasil.js",
	"./En/Markets/Latam.js": "./src/pages/En/Markets/Latam.js",
	"./En/Markets/PaymentMethodDetails.js": "./src/pages/En/Markets/PaymentMethodDetails.js",
	"./En/Markets/PaymentMethods.js": "./src/pages/En/Markets/PaymentMethods.js",
	"./En/Media/Blog.js": "./src/pages/En/Media/Blog.js",
	"./En/Media/PostDetail.js": "./src/pages/En/Media/PostDetail.js",
	"./En/Media/Press.js": "./src/pages/En/Media/Press.js",
	"./En/Media/index.js": "./src/pages/En/Media/index.js",
	"./En/Partners/GetInTouch.js": "./src/pages/En/Partners/GetInTouch.js",
	"./En/Partners/Partnerships.js": "./src/pages/En/Partners/Partnerships.js",
	"./En/Solutions/FraudRisk.js": "./src/pages/En/Solutions/FraudRisk.js",
	"./En/Solutions/InternationalsLocalSettlements.js": "./src/pages/En/Solutions/InternationalsLocalSettlements.js",
	"./En/Solutions/LocalInternational.js": "./src/pages/En/Solutions/LocalInternational.js",
	"./En/Solutions/Payins.js": "./src/pages/En/Solutions/Payins.js",
	"./En/Solutions/PayinsPayouts.js": "./src/pages/En/Solutions/PayinsPayouts.js",
	"./En/Solutions/PaymentMethods.js": "./src/pages/En/Solutions/PaymentMethods.js",
	"./En/Solutions/Payouts.js": "./src/pages/En/Solutions/Payouts.js",
	"./En/Solutions/PixAutomatico.js": "./src/pages/En/Solutions/PixAutomatico.js",
	"./En/Solutions/RiskManagement.js": "./src/pages/En/Solutions/RiskManagement.js",
	"./En/Solutions/index.js": "./src/pages/En/Solutions/index.js",
	"./En/Statics/Contact.js": "./src/pages/En/Statics/Contact.js",
	"./En/Statics/Ethics.js": "./src/pages/En/Statics/Ethics.js",
	"./En/Statics/Faqs/AboutPayRetailers.js": "./src/pages/En/Statics/Faqs/AboutPayRetailers.js",
	"./En/Statics/Faqs/PaymentsReceipts.js": "./src/pages/En/Statics/Faqs/PaymentsReceipts.js",
	"./En/Statics/Faqs/Reembolsos.js": "./src/pages/En/Statics/Faqs/Reembolsos.js",
	"./En/Statics/Faqs/Refunds.js": "./src/pages/En/Statics/Faqs/Refunds.js",
	"./En/Statics/PoliticasBr.js": "./src/pages/En/Statics/PoliticasBr.js",
	"./En/Statics/PrivacyPolicy.js": "./src/pages/En/Statics/PrivacyPolicy.js",
	"./En/Statics/TermsConditions.js": "./src/pages/En/Statics/TermsConditions.js",
	"./En/Statics/TestPage.js": "./src/pages/En/Statics/TestPage.js",
	"./En/Statics/ThankYou.js": "./src/pages/En/Statics/ThankYou.js",
	"./Es/AboutUs/Events.js": "./src/pages/Es/AboutUs/Events.js",
	"./Es/AboutUs/New.js": "./src/pages/Es/AboutUs/New.js",
	"./Es/AboutUs/WorkWithUs.js": "./src/pages/Es/AboutUs/WorkWithUs.js",
	"./Es/AboutUs/index.js": "./src/pages/Es/AboutUs/index.js",
	"./Es/Desarrolladores/Ayuda.js": "./src/pages/Es/Desarrolladores/Ayuda.js",
	"./Es/Desarrolladores/Integraciones.js": "./src/pages/Es/Desarrolladores/Integraciones.js",
	"./Es/Desarrolladores/Soporte.js": "./src/pages/Es/Desarrolladores/Soporte.js",
	"./Es/Home.js": "./src/pages/Es/Home.js",
	"./Es/Markets/Africa.js": "./src/pages/Es/Markets/Africa.js",
	"./Es/Markets/Latam.js": "./src/pages/Es/Markets/Latam.js",
	"./Es/Markets/PaymentMethods.js": "./src/pages/Es/Markets/PaymentMethods.js",
	"./Es/Markets/index.js": "./src/pages/Es/Markets/index.js",
	"./Es/Media/Blog.js": "./src/pages/Es/Media/Blog.js",
	"./Es/Media/PostDetail.js": "./src/pages/Es/Media/PostDetail.js",
	"./Es/Media/Prensa.js": "./src/pages/Es/Media/Prensa.js",
	"./Es/Media/index.js": "./src/pages/Es/Media/index.js",
	"./Es/Medios/Blog.js": "./src/pages/Es/Medios/Blog.js",
	"./Es/Medios/PostDetail.js": "./src/pages/Es/Medios/PostDetail.js",
	"./Es/Medios/Prensa.js": "./src/pages/Es/Medios/Prensa.js",
	"./Es/Medios/index.js": "./src/pages/Es/Medios/index.js",
	"./Es/Mercados/Africa.js": "./src/pages/Es/Mercados/Africa.js",
	"./Es/Mercados/Brasil.js": "./src/pages/Es/Mercados/Brasil.js",
	"./Es/Mercados/Latam.js": "./src/pages/Es/Mercados/Latam.js",
	"./Es/Mercados/PaymentMethodDetails.js": "./src/pages/Es/Mercados/PaymentMethodDetails.js",
	"./Es/Mercados/PaymentMethods.js": "./src/pages/Es/Mercados/PaymentMethods.js",
	"./Es/Mercados/_Latam.js": "./src/pages/Es/Mercados/_Latam.js",
	"./Es/Mercados/index.js": "./src/pages/Es/Mercados/index.js",
	"./Es/Nosotros/Eventos.js": "./src/pages/Es/Nosotros/Eventos.js",
	"./Es/Nosotros/Events.js": "./src/pages/Es/Nosotros/Events.js",
	"./Es/Nosotros/LineaEtica.js": "./src/pages/Es/Nosotros/LineaEtica.js",
	"./Es/Nosotros/New.js": "./src/pages/Es/Nosotros/New.js",
	"./Es/Nosotros/SobrePayretailers.js": "./src/pages/Es/Nosotros/SobrePayretailers.js",
	"./Es/Nosotros/TrabajaConNosotros.js": "./src/pages/Es/Nosotros/TrabajaConNosotros.js",
	"./Es/Nosotros/WorkWithUs.js": "./src/pages/Es/Nosotros/WorkWithUs.js",
	"./Es/Nosotros/index.js": "./src/pages/Es/Nosotros/index.js",
	"./Es/Partners/Contacto.js": "./src/pages/Es/Partners/Contacto.js",
	"./Es/Partners/Partnerships.js": "./src/pages/Es/Partners/Partnerships.js",
	"./Es/Soluciones/AsentamientosInternacionalesLocales.js": "./src/pages/Es/Soluciones/AsentamientosInternacionalesLocales.js",
	"./Es/Soluciones/FraudeRiesgo.js": "./src/pages/Es/Soluciones/FraudeRiesgo.js",
	"./Es/Soluciones/GestionDeFraudeRiesgos.js": "./src/pages/Es/Soluciones/GestionDeFraudeRiesgos.js",
	"./Es/Soluciones/LocalInternacional.js": "./src/pages/Es/Soluciones/LocalInternacional.js",
	"./Es/Soluciones/MetodosDePago.js": "./src/pages/Es/Soluciones/MetodosDePago.js",
	"./Es/Soluciones/Pagos.js": "./src/pages/Es/Soluciones/Pagos.js",
	"./Es/Soluciones/Payins.js": "./src/pages/Es/Soluciones/Payins.js",
	"./Es/Soluciones/PayinsPayouts.js": "./src/pages/Es/Soluciones/PayinsPayouts.js",
	"./Es/Soluciones/Payouts.js": "./src/pages/Es/Soluciones/Payouts.js",
	"./Es/Soluciones/PixAutomatico.js": "./src/pages/Es/Soluciones/PixAutomatico.js",
	"./Es/Soluciones/Riesgo.js": "./src/pages/Es/Soluciones/Riesgo.js",
	"./Es/Soluciones/index.js": "./src/pages/Es/Soluciones/index.js",
	"./Es/Statics/Contacto.js": "./src/pages/Es/Statics/Contacto.js",
	"./Es/Statics/CustomPage.js": "./src/pages/Es/Statics/CustomPage.js",
	"./Es/Statics/Faqs/AcercaDePayretailers.js": "./src/pages/Es/Statics/Faqs/AcercaDePayretailers.js",
	"./Es/Statics/Faqs/PagosRecibos.js": "./src/pages/Es/Statics/Faqs/PagosRecibos.js",
	"./Es/Statics/Faqs/Reembolsos.js": "./src/pages/Es/Statics/Faqs/Reembolsos.js",
	"./Es/Statics/PoliticasBr.js": "./src/pages/Es/Statics/PoliticasBr.js",
	"./Es/Statics/PoliticasPrivacidad.js": "./src/pages/Es/Statics/PoliticasPrivacidad.js",
	"./Es/Statics/RobertP.js": "./src/pages/Es/Statics/RobertP.js",
	"./Es/Statics/TermsConditions.js": "./src/pages/Es/Statics/TermsConditions.js",
	"./Es/Statics/ThankYou.js": "./src/pages/Es/Statics/ThankYou.js",
	"./Home.js": "./src/pages/Home.js",
	"./Market.js": "./src/pages/Market.js",
	"./Media.js": "./src/pages/Media.js",
	"./NotFound.js": "./src/pages/NotFound.js",
	"./Pt/Desenvolvedores/Ajuda.js": "./src/pages/Pt/Desenvolvedores/Ajuda.js",
	"./Pt/Desenvolvedores/Integracoes.js": "./src/pages/Pt/Desenvolvedores/Integracoes.js",
	"./Pt/Home.js": "./src/pages/Pt/Home.js",
	"./Pt/Media/Blog.js": "./src/pages/Pt/Media/Blog.js",
	"./Pt/Media/PostDetail.js": "./src/pages/Pt/Media/PostDetail.js",
	"./Pt/Media/Press.js": "./src/pages/Pt/Media/Press.js",
	"./Pt/Media/index.js": "./src/pages/Pt/Media/index.js",
	"./Pt/Mercados/Africa.js": "./src/pages/Pt/Mercados/Africa.js",
	"./Pt/Mercados/Brasil.js": "./src/pages/Pt/Mercados/Brasil.js",
	"./Pt/Mercados/Latam.js": "./src/pages/Pt/Mercados/Latam.js",
	"./Pt/Mercados/PaymentMethodDetails.js": "./src/pages/Pt/Mercados/PaymentMethodDetails.js",
	"./Pt/Mercados/PaymentMethods.js": "./src/pages/Pt/Mercados/PaymentMethods.js",
	"./Pt/Mercados/_Latam.js": "./src/pages/Pt/Mercados/_Latam.js",
	"./Pt/Mercados/_PaymentMethods.js": "./src/pages/Pt/Mercados/_PaymentMethods.js",
	"./Pt/Mercados/index.js": "./src/pages/Pt/Mercados/index.js",
	"./Pt/Midia/Blog.js": "./src/pages/Pt/Midia/Blog.js",
	"./Pt/Midia/Imprensa.js": "./src/pages/Pt/Midia/Imprensa.js",
	"./Pt/Midia/PostDetail.js": "./src/pages/Pt/Midia/PostDetail.js",
	"./Pt/Midia/Press.js": "./src/pages/Pt/Midia/Press.js",
	"./Pt/Midia/index.js": "./src/pages/Pt/Midia/index.js",
	"./Pt/Parceiros/GetInTouch.js": "./src/pages/Pt/Parceiros/GetInTouch.js",
	"./Pt/Parceiros/Parceiros.js": "./src/pages/Pt/Parceiros/Parceiros.js",
	"./Pt/SobreNos/Eventos.js": "./src/pages/Pt/SobreNos/Eventos.js",
	"./Pt/SobreNos/LinhaEtica.js": "./src/pages/Pt/SobreNos/LinhaEtica.js",
	"./Pt/SobreNos/New.js": "./src/pages/Pt/SobreNos/New.js",
	"./Pt/SobreNos/SobrePayretailers.js": "./src/pages/Pt/SobreNos/SobrePayretailers.js",
	"./Pt/SobreNos/TrabalharConConosco.js": "./src/pages/Pt/SobreNos/TrabalharConConosco.js",
	"./Pt/SobreNos/TrabalheConosco.js": "./src/pages/Pt/SobreNos/TrabalheConosco.js",
	"./Pt/SobreNos/index.js": "./src/pages/Pt/SobreNos/index.js",
	"./Pt/Solucoes/FraudesRiscos.js": "./src/pages/Pt/Solucoes/FraudesRiscos.js",
	"./Pt/Solucoes/InternationalsLocalSettlements.js": "./src/pages/Pt/Solucoes/InternationalsLocalSettlements.js",
	"./Pt/Solucoes/LocalInternacional.js": "./src/pages/Pt/Solucoes/LocalInternacional.js",
	"./Pt/Solucoes/MeiosDePagamento.js": "./src/pages/Pt/Solucoes/MeiosDePagamento.js",
	"./Pt/Solucoes/PagamentosCobrancas.js": "./src/pages/Pt/Solucoes/PagamentosCobrancas.js",
	"./Pt/Solucoes/Payins.js": "./src/pages/Pt/Solucoes/Payins.js",
	"./Pt/Solucoes/Payouts.js": "./src/pages/Pt/Solucoes/Payouts.js",
	"./Pt/Solucoes/PixAutomatico.js": "./src/pages/Pt/Solucoes/PixAutomatico.js",
	"./Pt/Solucoes/RiskManagement.js": "./src/pages/Pt/Solucoes/RiskManagement.js",
	"./Pt/Solucoes/index.js": "./src/pages/Pt/Solucoes/index.js",
	"./Pt/Solutions/FraudesRiscos.js": "./src/pages/Pt/Solutions/FraudesRiscos.js",
	"./Pt/Solutions/InternationalsLocalSettlements.js": "./src/pages/Pt/Solutions/InternationalsLocalSettlements.js",
	"./Pt/Solutions/Payouts.js": "./src/pages/Pt/Solutions/Payouts.js",
	"./Pt/Solutions/RiskManagement.js": "./src/pages/Pt/Solutions/RiskManagement.js",
	"./Pt/Solutions/index.js": "./src/pages/Pt/Solutions/index.js",
	"./Pt/Statics/Contato.js": "./src/pages/Pt/Statics/Contato.js",
	"./Pt/Statics/Faqs/PagamentosRecibos.js": "./src/pages/Pt/Statics/Faqs/PagamentosRecibos.js",
	"./Pt/Statics/Faqs/Reembolsos.js": "./src/pages/Pt/Statics/Faqs/Reembolsos.js",
	"./Pt/Statics/Faqs/SobrePayRetailers.js": "./src/pages/Pt/Statics/Faqs/SobrePayRetailers.js",
	"./Pt/Statics/Ouvidoria.js": "./src/pages/Pt/Statics/Ouvidoria.js",
	"./Pt/Statics/PoliticaPrivacidade.js": "./src/pages/Pt/Statics/PoliticaPrivacidade.js",
	"./Pt/Statics/PoliticasBr.js": "./src/pages/Pt/Statics/PoliticasBr.js",
	"./Pt/Statics/TermsConditions.js": "./src/pages/Pt/Statics/TermsConditions.js",
	"./Pt/Statics/ThankYou.js": "./src/pages/Pt/Statics/ThankYou.js",
	"./Solutions.js": "./src/pages/Solutions.js",
	"./index.js": "./src/pages/index.js",
	"pages/Aboutus.js": "./src/pages/Aboutus.js",
	"pages/Developers.js": "./src/pages/Developers.js",
	"pages/En/AboutUs/AboutPayretailers.js": "./src/pages/En/AboutUs/AboutPayretailers.js",
	"pages/En/AboutUs/Ethics.js": "./src/pages/En/AboutUs/Ethics.js",
	"pages/En/AboutUs/Events.js": "./src/pages/En/AboutUs/Events.js",
	"pages/En/AboutUs/New.js": "./src/pages/En/AboutUs/New.js",
	"pages/En/AboutUs/WorkWithUs.js": "./src/pages/En/AboutUs/WorkWithUs.js",
	"pages/En/AboutUs/index.js": "./src/pages/En/AboutUs/index.js",
	"pages/En/Developers/Help.js": "./src/pages/En/Developers/Help.js",
	"pages/En/Developers/Integrations.js": "./src/pages/En/Developers/Integrations.js",
	"pages/En/Home.js": "./src/pages/En/Home.js",
	"pages/En/Markets/Africa.js": "./src/pages/En/Markets/Africa.js",
	"pages/En/Markets/Brasil.js": "./src/pages/En/Markets/Brasil.js",
	"pages/En/Markets/Latam.js": "./src/pages/En/Markets/Latam.js",
	"pages/En/Markets/PaymentMethodDetails.js": "./src/pages/En/Markets/PaymentMethodDetails.js",
	"pages/En/Markets/PaymentMethods.js": "./src/pages/En/Markets/PaymentMethods.js",
	"pages/En/Media/Blog.js": "./src/pages/En/Media/Blog.js",
	"pages/En/Media/PostDetail.js": "./src/pages/En/Media/PostDetail.js",
	"pages/En/Media/Press.js": "./src/pages/En/Media/Press.js",
	"pages/En/Media/index.js": "./src/pages/En/Media/index.js",
	"pages/En/Partners/GetInTouch.js": "./src/pages/En/Partners/GetInTouch.js",
	"pages/En/Partners/Partnerships.js": "./src/pages/En/Partners/Partnerships.js",
	"pages/En/Solutions/FraudRisk.js": "./src/pages/En/Solutions/FraudRisk.js",
	"pages/En/Solutions/InternationalsLocalSettlements.js": "./src/pages/En/Solutions/InternationalsLocalSettlements.js",
	"pages/En/Solutions/LocalInternational.js": "./src/pages/En/Solutions/LocalInternational.js",
	"pages/En/Solutions/Payins.js": "./src/pages/En/Solutions/Payins.js",
	"pages/En/Solutions/PayinsPayouts.js": "./src/pages/En/Solutions/PayinsPayouts.js",
	"pages/En/Solutions/PaymentMethods.js": "./src/pages/En/Solutions/PaymentMethods.js",
	"pages/En/Solutions/Payouts.js": "./src/pages/En/Solutions/Payouts.js",
	"pages/En/Solutions/PixAutomatico.js": "./src/pages/En/Solutions/PixAutomatico.js",
	"pages/En/Solutions/RiskManagement.js": "./src/pages/En/Solutions/RiskManagement.js",
	"pages/En/Solutions/index.js": "./src/pages/En/Solutions/index.js",
	"pages/En/Statics/Contact.js": "./src/pages/En/Statics/Contact.js",
	"pages/En/Statics/Ethics.js": "./src/pages/En/Statics/Ethics.js",
	"pages/En/Statics/Faqs/AboutPayRetailers.js": "./src/pages/En/Statics/Faqs/AboutPayRetailers.js",
	"pages/En/Statics/Faqs/PaymentsReceipts.js": "./src/pages/En/Statics/Faqs/PaymentsReceipts.js",
	"pages/En/Statics/Faqs/Reembolsos.js": "./src/pages/En/Statics/Faqs/Reembolsos.js",
	"pages/En/Statics/Faqs/Refunds.js": "./src/pages/En/Statics/Faqs/Refunds.js",
	"pages/En/Statics/PoliticasBr.js": "./src/pages/En/Statics/PoliticasBr.js",
	"pages/En/Statics/PrivacyPolicy.js": "./src/pages/En/Statics/PrivacyPolicy.js",
	"pages/En/Statics/TermsConditions.js": "./src/pages/En/Statics/TermsConditions.js",
	"pages/En/Statics/TestPage.js": "./src/pages/En/Statics/TestPage.js",
	"pages/En/Statics/ThankYou.js": "./src/pages/En/Statics/ThankYou.js",
	"pages/Es/AboutUs/Events.js": "./src/pages/Es/AboutUs/Events.js",
	"pages/Es/AboutUs/New.js": "./src/pages/Es/AboutUs/New.js",
	"pages/Es/AboutUs/WorkWithUs.js": "./src/pages/Es/AboutUs/WorkWithUs.js",
	"pages/Es/AboutUs/index.js": "./src/pages/Es/AboutUs/index.js",
	"pages/Es/Desarrolladores/Ayuda.js": "./src/pages/Es/Desarrolladores/Ayuda.js",
	"pages/Es/Desarrolladores/Integraciones.js": "./src/pages/Es/Desarrolladores/Integraciones.js",
	"pages/Es/Desarrolladores/Soporte.js": "./src/pages/Es/Desarrolladores/Soporte.js",
	"pages/Es/Home.js": "./src/pages/Es/Home.js",
	"pages/Es/Markets/Africa.js": "./src/pages/Es/Markets/Africa.js",
	"pages/Es/Markets/Latam.js": "./src/pages/Es/Markets/Latam.js",
	"pages/Es/Markets/PaymentMethods.js": "./src/pages/Es/Markets/PaymentMethods.js",
	"pages/Es/Markets/index.js": "./src/pages/Es/Markets/index.js",
	"pages/Es/Media/Blog.js": "./src/pages/Es/Media/Blog.js",
	"pages/Es/Media/PostDetail.js": "./src/pages/Es/Media/PostDetail.js",
	"pages/Es/Media/Prensa.js": "./src/pages/Es/Media/Prensa.js",
	"pages/Es/Media/index.js": "./src/pages/Es/Media/index.js",
	"pages/Es/Medios/Blog.js": "./src/pages/Es/Medios/Blog.js",
	"pages/Es/Medios/PostDetail.js": "./src/pages/Es/Medios/PostDetail.js",
	"pages/Es/Medios/Prensa.js": "./src/pages/Es/Medios/Prensa.js",
	"pages/Es/Medios/index.js": "./src/pages/Es/Medios/index.js",
	"pages/Es/Mercados/Africa.js": "./src/pages/Es/Mercados/Africa.js",
	"pages/Es/Mercados/Brasil.js": "./src/pages/Es/Mercados/Brasil.js",
	"pages/Es/Mercados/Latam.js": "./src/pages/Es/Mercados/Latam.js",
	"pages/Es/Mercados/PaymentMethodDetails.js": "./src/pages/Es/Mercados/PaymentMethodDetails.js",
	"pages/Es/Mercados/PaymentMethods.js": "./src/pages/Es/Mercados/PaymentMethods.js",
	"pages/Es/Mercados/_Latam.js": "./src/pages/Es/Mercados/_Latam.js",
	"pages/Es/Mercados/index.js": "./src/pages/Es/Mercados/index.js",
	"pages/Es/Nosotros/Eventos.js": "./src/pages/Es/Nosotros/Eventos.js",
	"pages/Es/Nosotros/Events.js": "./src/pages/Es/Nosotros/Events.js",
	"pages/Es/Nosotros/LineaEtica.js": "./src/pages/Es/Nosotros/LineaEtica.js",
	"pages/Es/Nosotros/New.js": "./src/pages/Es/Nosotros/New.js",
	"pages/Es/Nosotros/SobrePayretailers.js": "./src/pages/Es/Nosotros/SobrePayretailers.js",
	"pages/Es/Nosotros/TrabajaConNosotros.js": "./src/pages/Es/Nosotros/TrabajaConNosotros.js",
	"pages/Es/Nosotros/WorkWithUs.js": "./src/pages/Es/Nosotros/WorkWithUs.js",
	"pages/Es/Nosotros/index.js": "./src/pages/Es/Nosotros/index.js",
	"pages/Es/Partners/Contacto.js": "./src/pages/Es/Partners/Contacto.js",
	"pages/Es/Partners/Partnerships.js": "./src/pages/Es/Partners/Partnerships.js",
	"pages/Es/Soluciones/AsentamientosInternacionalesLocales.js": "./src/pages/Es/Soluciones/AsentamientosInternacionalesLocales.js",
	"pages/Es/Soluciones/FraudeRiesgo.js": "./src/pages/Es/Soluciones/FraudeRiesgo.js",
	"pages/Es/Soluciones/GestionDeFraudeRiesgos.js": "./src/pages/Es/Soluciones/GestionDeFraudeRiesgos.js",
	"pages/Es/Soluciones/LocalInternacional.js": "./src/pages/Es/Soluciones/LocalInternacional.js",
	"pages/Es/Soluciones/MetodosDePago.js": "./src/pages/Es/Soluciones/MetodosDePago.js",
	"pages/Es/Soluciones/Pagos.js": "./src/pages/Es/Soluciones/Pagos.js",
	"pages/Es/Soluciones/Payins.js": "./src/pages/Es/Soluciones/Payins.js",
	"pages/Es/Soluciones/PayinsPayouts.js": "./src/pages/Es/Soluciones/PayinsPayouts.js",
	"pages/Es/Soluciones/Payouts.js": "./src/pages/Es/Soluciones/Payouts.js",
	"pages/Es/Soluciones/PixAutomatico.js": "./src/pages/Es/Soluciones/PixAutomatico.js",
	"pages/Es/Soluciones/Riesgo.js": "./src/pages/Es/Soluciones/Riesgo.js",
	"pages/Es/Soluciones/index.js": "./src/pages/Es/Soluciones/index.js",
	"pages/Es/Statics/Contacto.js": "./src/pages/Es/Statics/Contacto.js",
	"pages/Es/Statics/CustomPage.js": "./src/pages/Es/Statics/CustomPage.js",
	"pages/Es/Statics/Faqs/AcercaDePayretailers.js": "./src/pages/Es/Statics/Faqs/AcercaDePayretailers.js",
	"pages/Es/Statics/Faqs/PagosRecibos.js": "./src/pages/Es/Statics/Faqs/PagosRecibos.js",
	"pages/Es/Statics/Faqs/Reembolsos.js": "./src/pages/Es/Statics/Faqs/Reembolsos.js",
	"pages/Es/Statics/PoliticasBr.js": "./src/pages/Es/Statics/PoliticasBr.js",
	"pages/Es/Statics/PoliticasPrivacidad.js": "./src/pages/Es/Statics/PoliticasPrivacidad.js",
	"pages/Es/Statics/RobertP.js": "./src/pages/Es/Statics/RobertP.js",
	"pages/Es/Statics/TermsConditions.js": "./src/pages/Es/Statics/TermsConditions.js",
	"pages/Es/Statics/ThankYou.js": "./src/pages/Es/Statics/ThankYou.js",
	"pages/Home.js": "./src/pages/Home.js",
	"pages/Market.js": "./src/pages/Market.js",
	"pages/Media.js": "./src/pages/Media.js",
	"pages/NotFound.js": "./src/pages/NotFound.js",
	"pages/Pt/Desenvolvedores/Ajuda.js": "./src/pages/Pt/Desenvolvedores/Ajuda.js",
	"pages/Pt/Desenvolvedores/Integracoes.js": "./src/pages/Pt/Desenvolvedores/Integracoes.js",
	"pages/Pt/Home.js": "./src/pages/Pt/Home.js",
	"pages/Pt/Media/Blog.js": "./src/pages/Pt/Media/Blog.js",
	"pages/Pt/Media/PostDetail.js": "./src/pages/Pt/Media/PostDetail.js",
	"pages/Pt/Media/Press.js": "./src/pages/Pt/Media/Press.js",
	"pages/Pt/Media/index.js": "./src/pages/Pt/Media/index.js",
	"pages/Pt/Mercados/Africa.js": "./src/pages/Pt/Mercados/Africa.js",
	"pages/Pt/Mercados/Brasil.js": "./src/pages/Pt/Mercados/Brasil.js",
	"pages/Pt/Mercados/Latam.js": "./src/pages/Pt/Mercados/Latam.js",
	"pages/Pt/Mercados/PaymentMethodDetails.js": "./src/pages/Pt/Mercados/PaymentMethodDetails.js",
	"pages/Pt/Mercados/PaymentMethods.js": "./src/pages/Pt/Mercados/PaymentMethods.js",
	"pages/Pt/Mercados/_Latam.js": "./src/pages/Pt/Mercados/_Latam.js",
	"pages/Pt/Mercados/_PaymentMethods.js": "./src/pages/Pt/Mercados/_PaymentMethods.js",
	"pages/Pt/Mercados/index.js": "./src/pages/Pt/Mercados/index.js",
	"pages/Pt/Midia/Blog.js": "./src/pages/Pt/Midia/Blog.js",
	"pages/Pt/Midia/Imprensa.js": "./src/pages/Pt/Midia/Imprensa.js",
	"pages/Pt/Midia/PostDetail.js": "./src/pages/Pt/Midia/PostDetail.js",
	"pages/Pt/Midia/Press.js": "./src/pages/Pt/Midia/Press.js",
	"pages/Pt/Midia/index.js": "./src/pages/Pt/Midia/index.js",
	"pages/Pt/Parceiros/GetInTouch.js": "./src/pages/Pt/Parceiros/GetInTouch.js",
	"pages/Pt/Parceiros/Parceiros.js": "./src/pages/Pt/Parceiros/Parceiros.js",
	"pages/Pt/SobreNos/Eventos.js": "./src/pages/Pt/SobreNos/Eventos.js",
	"pages/Pt/SobreNos/LinhaEtica.js": "./src/pages/Pt/SobreNos/LinhaEtica.js",
	"pages/Pt/SobreNos/New.js": "./src/pages/Pt/SobreNos/New.js",
	"pages/Pt/SobreNos/SobrePayretailers.js": "./src/pages/Pt/SobreNos/SobrePayretailers.js",
	"pages/Pt/SobreNos/TrabalharConConosco.js": "./src/pages/Pt/SobreNos/TrabalharConConosco.js",
	"pages/Pt/SobreNos/TrabalheConosco.js": "./src/pages/Pt/SobreNos/TrabalheConosco.js",
	"pages/Pt/SobreNos/index.js": "./src/pages/Pt/SobreNos/index.js",
	"pages/Pt/Solucoes/FraudesRiscos.js": "./src/pages/Pt/Solucoes/FraudesRiscos.js",
	"pages/Pt/Solucoes/InternationalsLocalSettlements.js": "./src/pages/Pt/Solucoes/InternationalsLocalSettlements.js",
	"pages/Pt/Solucoes/LocalInternacional.js": "./src/pages/Pt/Solucoes/LocalInternacional.js",
	"pages/Pt/Solucoes/MeiosDePagamento.js": "./src/pages/Pt/Solucoes/MeiosDePagamento.js",
	"pages/Pt/Solucoes/PagamentosCobrancas.js": "./src/pages/Pt/Solucoes/PagamentosCobrancas.js",
	"pages/Pt/Solucoes/Payins.js": "./src/pages/Pt/Solucoes/Payins.js",
	"pages/Pt/Solucoes/Payouts.js": "./src/pages/Pt/Solucoes/Payouts.js",
	"pages/Pt/Solucoes/PixAutomatico.js": "./src/pages/Pt/Solucoes/PixAutomatico.js",
	"pages/Pt/Solucoes/RiskManagement.js": "./src/pages/Pt/Solucoes/RiskManagement.js",
	"pages/Pt/Solucoes/index.js": "./src/pages/Pt/Solucoes/index.js",
	"pages/Pt/Solutions/FraudesRiscos.js": "./src/pages/Pt/Solutions/FraudesRiscos.js",
	"pages/Pt/Solutions/InternationalsLocalSettlements.js": "./src/pages/Pt/Solutions/InternationalsLocalSettlements.js",
	"pages/Pt/Solutions/Payouts.js": "./src/pages/Pt/Solutions/Payouts.js",
	"pages/Pt/Solutions/RiskManagement.js": "./src/pages/Pt/Solutions/RiskManagement.js",
	"pages/Pt/Solutions/index.js": "./src/pages/Pt/Solutions/index.js",
	"pages/Pt/Statics/Contato.js": "./src/pages/Pt/Statics/Contato.js",
	"pages/Pt/Statics/Faqs/PagamentosRecibos.js": "./src/pages/Pt/Statics/Faqs/PagamentosRecibos.js",
	"pages/Pt/Statics/Faqs/Reembolsos.js": "./src/pages/Pt/Statics/Faqs/Reembolsos.js",
	"pages/Pt/Statics/Faqs/SobrePayRetailers.js": "./src/pages/Pt/Statics/Faqs/SobrePayRetailers.js",
	"pages/Pt/Statics/Ouvidoria.js": "./src/pages/Pt/Statics/Ouvidoria.js",
	"pages/Pt/Statics/PoliticaPrivacidade.js": "./src/pages/Pt/Statics/PoliticaPrivacidade.js",
	"pages/Pt/Statics/PoliticasBr.js": "./src/pages/Pt/Statics/PoliticasBr.js",
	"pages/Pt/Statics/TermsConditions.js": "./src/pages/Pt/Statics/TermsConditions.js",
	"pages/Pt/Statics/ThankYou.js": "./src/pages/Pt/Statics/ThankYou.js",
	"pages/Solutions.js": "./src/pages/Solutions.js",
	"pages/index.js": "./src/pages/index.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/pages sync recursive \\.js$";